import { request, createParams } from '../utils-tools/request';
import { Local } from '../utils/local';
const domain = window.location.host.indexOf('localhost') == -1 ? window.location.origin : 'http://hxkht.rel-s.yunduoketang.cn';
const commonPath = '/saas-business'; // 获取flag值

export async function IS_SUPPORT_SEO() {
  let response = await request(createParams(`${commonPath}/v1/sysConfigSeo/getCompanySeoConfig/${Local.get('schoolId') ? Local.get('schoolId') : ''}?domain=${domain}`, 'GET'));
  return response;
}